import { IKnmSubjectTypesERVK } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectTypesERVK';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryKnmSubjectTypesSelectOption = makeCreateDictionarySelectOption<IKnmSubjectTypesERVK>(
  'code',
  'title',
);
